import _FieldArray from "redux-form/es/FieldArray";
import _Select from "@material-ui/core/esm/Select";
import _MenuItem from "@material-ui/core/esm/MenuItem";
import _Field from "redux-form/es/Field";
import React from 'react';
import classnames from 'classnames';
import GreyUnderlinedDropdownInput from 'swag-client-common/components/inputs/grey-underlined-dropdown-input/grey-underlined-dropdown-input';
import { GreyUnderlinedInput } from 'swag-client-common/components/inputs/grey-underlined-input';
import { HUBSPOT_FIELDS } from 'swag-common/constants/hubspot';
import { required, phoneNumber, email, maxLength, minLength, url } from 'swag-client-common/utils/redux-form-validators';
import classes from './contact-form.module.scss';
const interestedInOptions = ['Bulk Ordering', 'Swag Distribution', 'Swag In a Box', 'Corporate Gifting', 'Company Stores'];
export const ContactFormComponent = ({
  yearly,
  employees
}) => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
  className: classes.section
}, /*#__PURE__*/React.createElement(_Field, {
  dataInput: "FirstName",
  name: HUBSPOT_FIELDS.FIRST_NAME,
  component: GreyUnderlinedInput,
  containerClassName: classes.inputContainer,
  className: classes.input,
  type: "text",
  label: "First Name *",
  hintText: "Your First Name",
  validate: [required, minLength(2), maxLength(50)],
  autoComplete: "disabled"
}), /*#__PURE__*/React.createElement(_Field, {
  dataInput: "LastName",
  name: HUBSPOT_FIELDS.LAST_NAME,
  component: GreyUnderlinedInput,
  containerClassName: classes.inputContainer,
  className: classes.input,
  type: "text",
  label: "Last Name *",
  validate: [required, minLength(2), maxLength(50)],
  hintText: "Your Last Name",
  autoComplete: "disabled"
})), /*#__PURE__*/React.createElement("div", {
  className: classes.section
}, /*#__PURE__*/React.createElement(_Field, {
  dataInput: "Email",
  name: HUBSPOT_FIELDS.EMAIL,
  component: GreyUnderlinedInput,
  containerClassName: classes.inputContainer,
  className: classes.input,
  type: "text",
  label: "Work Email *",
  validate: [required, email],
  hintText: "E.g. janet@thegoodplace.com",
  autoComplete: "disabled"
}), /*#__PURE__*/React.createElement(_Field, {
  dataInput: "Phone",
  name: HUBSPOT_FIELDS.PHONE_NUMBER,
  component: GreyUnderlinedInput,
  containerClassName: classes.inputContainer,
  className: classes.input,
  type: "text",
  label: "Phone Number *",
  validate: [required, phoneNumber, minLength(7), maxLength(20)],
  hintText: "Your Phone Number",
  autoComplete: "disabled"
})), /*#__PURE__*/React.createElement("div", {
  className: classes.section
}, /*#__PURE__*/React.createElement(_Field, {
  dataInput: "CompanyName",
  name: HUBSPOT_FIELDS.COMPANY_NAME,
  component: GreyUnderlinedInput,
  containerClassName: classes.inputContainer,
  className: classes.input,
  type: "text",
  label: "Company Name *",
  validate: [required, minLength(2), maxLength(50)],
  hintText: "Your Company",
  autoComplete: "disabled"
}), /*#__PURE__*/React.createElement(_Field, {
  dataInput: "CompanyUrl",
  name: HUBSPOT_FIELDS.COMPANY_URL,
  component: GreyUnderlinedInput,
  containerClassName: classes.inputContainer,
  className: classes.input,
  type: "text",
  label: "Company Website *",
  validate: [required, url, minLength(2), maxLength(50)],
  hintText: "www.website.com",
  autoComplete: "disabled"
})), /*#__PURE__*/React.createElement("div", {
  className: classes.section
}, /*#__PURE__*/React.createElement(_Field, {
  name: HUBSPOT_FIELDS.EMPLOYEES_COUNT,
  component: GreyUnderlinedDropdownInput,
  wrapperClassName: classnames(classes.inputContainer, classes.selectContainer),
  type: "text",
  label: "How many employees? *",
  validate: [required],
  hintText: "Please select",
  values: employees
}), /*#__PURE__*/React.createElement(_Field, {
  name: HUBSPOT_FIELDS.YEARLY,
  component: GreyUnderlinedDropdownInput,
  wrapperClassName: classnames(classes.inputContainer, classes.selectContainer),
  type: "text",
  label: "Yearly swag spent? *",
  hintText: "Please select",
  validate: [required],
  values: yearly
})), /*#__PURE__*/React.createElement("div", {
  className: classes.section
}, /*#__PURE__*/React.createElement(_FieldArray, {
  name: "interestedIn",
  validate: [required, minLength(1)],
  component: props => {
    var _props$fields$getAll;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.multipleSelectContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.title
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.titleLine1
    }, "What are you interested in? *")), /*#__PURE__*/React.createElement(_Select, {
      multiple: true,
      fullWidth: true,
      displayEmpty: true,
      value: (_props$fields$getAll = props.fields.getAll()) !== null && _props$fields$getAll !== void 0 ? _props$fields$getAll : [],
      renderValue: selected => {
        if (selected.length === 0) {
          return /*#__PURE__*/React.createElement("span", {
            className: classes.placeholder
          }, "Check all that apply");
        }
        return selected.join(', ');
      },
      onChange: event => {
        props.fields.removeAll();
        event.target.value.forEach(props.fields.push);
      },
      MenuProps: {
        getContentAnchorEl: null
      }
    }, interestedInOptions.map(app => /*#__PURE__*/React.createElement(_MenuItem, {
      key: app,
      value: app
    }, app))));
  }
})));